import { FormControlLabel, Checkbox, Typography, TextField, Button, CircularProgress } from "@mui/material";


import { TextInput } from "../../../../../shared/ui/common/index.js";




/** Presentational section; state and actions remain owned by its parent. */
export default function CompanyInvoiceTab({ TabPanel, value, data, setData, submitEdit, loadingSumbit }) {
  return (
<TabPanel value={value} index={6}>
            <div className="grid md:grid-cols-4 flex-wrap items-center gap-5">
              <FormControlLabel
                sx={{
                  border: (theme) =>
                    theme.palette.mode === "light"
                      ? "1px solid rgba(0, 0, 0, 0.23)"
                      : "1px solid rgba(55, 255, 255, 0.23)",
                  borderRadius: "4px",
                  height: "3.07rem",
                  marginLeft: "0px !important",
                  marginRight: "0px !important",
                  width: "100%",
                }}
                control={
                  <Checkbox checked={Boolean(data?.invoiceNinePercentDiscount)} />
                }
                onChange={(e) => {
                  setData({
                    ...data,
                    invoiceNinePercentDiscount:
                      !data?.invoiceNinePercentDiscount,
                  });
                }}
                label={
                  <Typography
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "light"
                          ? "rgba(0, 0, 0, 0.6)"
                          : "rgba(255, 255, 255, 0.7)",
                      fontSize: { md: "0.75rem !important" },
                      fontWeight: "400 !important",
                    }}
                  >
                    روش قیمت گذاری : همراه با ۹ درصد
                  </Typography>
                }
              />
              {/*    <FormControlLabel
                sx={{
                  border: (theme) =>
                    theme.palette.mode === "light"
                      ? "1px solid rgba(0, 0, 0, 0.23)"
                      : "1px solid rgba(55, 255, 255, 0.23)",
                  borderRadius: "4px",
                  height: "3.07rem",
                  marginLeft: "0px !important",
                  marginRight: "0px !important",
                  width: "100%",
                }}
                control={<Checkbox checked={Boolean(data?.showPlanInCheckout)} />}
                onChange={(e) => {
                  setData({
                    ...data,
                    showPlanInCheckout: !data?.showPlanInCheckout,
                  });
                }}
                label={
                  <Typography
                    sx={{
                      color: (theme) =>
                        theme.palette.mode === "light"
                          ? "rgba(0, 0, 0, 0.6)"
                          : "rgba(255, 255, 255, 0.7)",
                      fontSize: { md: "0.75rem !important" },
                      fontWeight: "400 !important",
                    }}
                  >
                    نمایش طرح ها در صفحه چک اوت
                  </Typography>
                }
              /> */}
              {/*     <Dropdown
                title="تنظیمات کسر کارمزد طرح"
                value={planData?.find(
                  (item) => item?.id === data?.planWageSource
                )}
                data={planData}
                change={(e) => setData({ ...data, planWageSource: e?.id })}
              /> */}
              <TextInput
                label=" تغیر نام مالیات در صفحه چک اوت"
                currentValue={data?.vatTitle}
                change={(e) => setData({ ...data, vatTitle: e })}
              />
              <div className="col-span-4">
                {" "}
                <TextField
                  multiline
                  rows={2}
                  fullWidth
                  label=" توضیحات صفحه پرداخت"
                  value={data?.checkoutDescription}
                  onChange={(e) =>
                    setData({
                      ...data,
                      checkoutDescription: e.target.value,
                    })
                  }
                />
              </div>

              <div className="flex col-span-4 justify-end w-full mt-7">
                <Button
                  onClick={submitEdit}
                  s
                  variant="contained"
                  disabled={loadingSumbit}
                  sx={{ width: { xs: "100%", sm: "auto" } }}
                >
                  {loadingSumbit ? <CircularProgress /> : <>ثبت اطلاعات</>}
                </Button>
              </div>
            </div>
          </TabPanel>
  );
}
